
import language from "./language.json";
export default {
  props: ["isShow", "updataShow", "headerData"],
  data() {
    return {
      language,
    };
  },
  methods: {
    normalizeSiteUrl(url) {
      try {
        const u = new URL(url);
        if (!u.hostname.startsWith("www.") && u.hostname.split(".").length === 2) {
          u.hostname = "www." + u.hostname;
        }
        return u.origin;
      } catch (e) {
        return url;
      }
    },
    /** 规范化 path，去掉首部 /，若为根路径 / 则返回空字符串，避免 URL 中出现重复的 / */
    normalizePath(path) {
      if (!path || path === "/") return "";
      return path.replace(/^\/+/, "");
    },
    getHref(item) {
			let url = this.headerData.origin || "https://www.baidu.com";

			if (item.language === "English") {
				return url.split("//")[0] + "//" + "www." + url.split("//")[1];
			} else {
				url =
					url.split("//")[0] + "//" + "www." + url.split("//")[1] +"/"+ item.href;
				return url;
			}
		},

  },
};
